module["exports"] = [
  "#{street_name}, پلاک #{building_number}",
  "#{street_name}, #{street_name}, پلاک #{building_number}"
];
